import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  UnitsTransmissionStatus,
  UnitWithTransmissionStatus,
} from 'src/app/units/models/unit-transmission-status';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import {
  Convoy,
  Group,
  OperationGroup,
} from './models/collection-vehicle.model';
import {
  distinctUntilChanged,
  first,
  map,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { StateCustomPanelVehicleService } from './service/state-custom-panel-vehicle.service';
import { VehicleService } from '../../services/vehicle.service';
import { UnitService } from 'src/app/units/services/unit.service';
import {
  UserTracker,
  ScreenView,
  StructureGrid,
  UnitItem,
} from 'src/app/multiview/models/interfaces';
import Swal from 'sweetalert2';
import { VehicleConfigService } from '../../services/vehicle-config.service';
import { MapService } from '../../services/map.service';
import { FollowService } from '../../services/follow.service';
import {
  CollectionActionEvent,
  DisplayCollectionEvent,
} from './models/collection.types';
import { TransmissionStatusInformation } from './models/transmission-status-information.model';
import { Observable, Subject } from 'rxjs';
import { convertSecondsToTimeString } from './helpers/convert-seconds-to-time-string';
import { VehicleEyeStateService } from './service/vehicle-eye-state.service';
import { DataCollectionCreate } from './models/data-collection-create.model';
import { PanelVehicleCommunicationService } from './service/panel-vehicle-communication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitCollectionService } from './service/unit-collection.service';
import { IsReloadPageService } from './service/is-reload-page.service';
import { StateVehicleService } from './service/state-vehicle.service';
import {
  VehicleStateLocal,
  ViewOptionState,
} from './models/vehicle-state-local.model';
import { ManagerDriversService } from './service/manager-drivers.service';
import { DriverDescription } from './models/DriverDescription.model';
import { MultiviewService } from '../../../multiview/services/multiview.service';
import { PermissionService } from 'src/app/permiss/permission.service';


@Component({
  selector: 'app-content-panel-vehicles',
  templateUrl: './content-panel-vehicles.component.html',
  styleUrls: ['./content-panel-vehicles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentPanelVehiclesComponent implements OnInit, OnDestroy {
  @Output() eventDisplayGroup = new EventEmitter<boolean>();

  private units: UnitWithTransmissionStatus[] = [];
  private oldUnits: any[] = [];
  /* public collectionUnits: OperationGroup[] = []; */
  private unitsCollectionOrigin: OperationGroup[] = [];
  private isCachedCollectionActive = false;
  private valueEventFilter: { value: string; isActive: boolean } = {
    value: '',
    isActive: false,
  };
  public servicePanel: StateCustomPanelVehicleService;
  public newVehicleService: UnitService;
  public isLoadingOldService = true;
  public isActiveButtonToggleContainer = false;
  public transmissionStatusIdButtonToggleContainer = 0;
  public transmissionStatusInformation: TransmissionStatusInformation[] = [];
  public isFormatedOperation = false;
  readonly transmissionStatus$ = new Observable<
    TransmissionStatusInformation[]
  >();
  private onDestroy$ = new Subject<boolean>();
  public nameSpinner = 'loadingContentPanelVehicles';
  readonly unitsCollection$ = new Observable<OperationGroup[]>();
  readonly unitsWithTransmission$ = new Observable<
    UnitWithTransmissionStatus[]
  >();
  public isLoadingCollection = true;
  public isLoadingVehicleService = true;
  private hasVisited = false;
  private vehicleStateLocal: Map<string, VehicleStateLocal> = new Map();
  isLoadingStateVehicle$ = this.stateVehicleService.isLoading$;
  private isActiveFilterEyer = false;

  public editUnitName : boolean = false;

  constructor(
    private _unitService: UnitTransmissionStatusService,
    private cdRef: ChangeDetectorRef,
    _serviceCustomPanelVehicle: StateCustomPanelVehicleService,
    private _oldVehicleService: VehicleService,
    _newVehicleService: UnitService,
    private _vehicleConfigService: VehicleConfigService,
    private mapService: MapService,
    private followService: FollowService,
    private vehicleEyeStateService: VehicleEyeStateService,
    private panelVehicleCommunicationService: PanelVehicleCommunicationService,
    private spinner: NgxSpinnerService,
    private unitCollectionService: UnitCollectionService,
    private isReloadPage: IsReloadPageService,
    private stateVehicleService: StateVehicleService,
    private managerDriversServices: ManagerDriversService,
    private multiviewService: MultiviewService,
    private permissionService : PermissionService,
  ) {

    permissionService.hasPermission("vehicle_edit_name").then((res)=>{
      if(res){
        this.editUnitName = true;
      }
    })
    this.isActiveFilterEyer = unitCollectionService.getStateFilterEye();
    this.stateVehicleService.state$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((_) => (this.vehicleStateLocal = _));

    this.servicePanel = _serviceCustomPanelVehicle;
    this.newVehicleService = _newVehicleService;
    this.unitsCollection$ = unitCollectionService.getUnitsCollection.pipe(
      tap((_) => {
        // if (_.length > 0) {
        this.isLoadingCollection = false;
        // }
      })
    );
    this.unitsWithTransmission$ =
      unitCollectionService.getUnitsWithTransmission;

    /* this.unitsWithTransmission$ =
      unitCollectionService.getUnitsWithTransmission.pipe(
        tap((_) => console.log('UNITS SERVICE: ', _))
      ); */

    this.transmissionStatus$ =
      unitCollectionService.getQuantityUnitsForTransmission.pipe(
        map((_) => _.map((_) => ({ ..._ }))),
        distinctUntilChanged((prev, current) => {
          return prev.every((prevUnit, index) => {
            return prevUnit.quantityVehicle === current[index].quantityVehicle;
          });
        }),
        map((_) =>
          _.sort((a, b) => a.transmissionStatusId - b.transmissionStatusId)
        )
      );

    unitCollectionService.getUnitsCollectionOrigin
      .pipe(
        takeUntil(this.onDestroy$),
        tap((_) => {
          this.unitsCollectionOrigin = _;
        })
      )
      .subscribe();

    /* this.transmissionStatus$ =
      this._unitService.getUnitsTransmissionStates.pipe(
        map((units) =>
          units.map((unit) => ({
            ...unit,
          }))
        ),
        distinctUntilChanged((prev, current) => {
          return prev.every((prevUnit, index) => {
            return (
              prevUnit.transmissionMatchingUnits ===
              current[index].transmissionMatchingUnits
            );
          });
        }),
        map((units: UnitsTransmissionStatus[]) => {
          const mappedUnits = units.map((unit) => {
            return {
              transmissionStatusId: unit.transmissionStatusId,
              quantityVehicle: unit.transmissionMatchingUnits,
            };
          });
          return mappedUnits.sort(
            (a, b) => a.transmissionStatusId - b.transmissionStatusId
          );
        })
      ); */
  }

  showSpinner() {
    this.spinner.show(this.nameSpinner);
  }

  ngOnInit(): void {
    this.showSpinner();
    this.hasVisited = this.isReloadPage.hasVisited;
    if (!this.hasVisited) {
      this.isReloadPage.checkPage();
    }

    this.oldUnits = this._oldVehicleService.vehicles;
    if (this.oldUnits.length === 0) {
      this._oldVehicleService.dataCompleted
        .pipe(
          takeUntil(this.onDestroy$),
          first(),
          tap((_) => {
            this.oldUnits = _;
            this.managerDriversServices.loadData(_);
            this.isLoadingVehicleService = false;
          })
        )
        .subscribe();
    } else {
      this.isLoadingVehicleService = false;
      this.cdRef.detectChanges();
      this.managerDriversServices.loadData(this.oldUnits);
      /* if (!this.hasVisited) {
        setTimeout(() => {
          this.isLoadingVehicleService = false;
          this.cdRef.detectChanges();
        }, 1000);
      } else {
        this.isLoadingVehicleService = false;
      } */
    }
    /* this._unitService.getUnitsTransmissionStatus
      .pipe(
        takeUntil(this.onDestroy$),
        map((units: UnitWithTransmissionStatus[]) => {
          this.originalUnits = units;
          this.cacheCollectionsUnits = this.groupUnits(units);
          const filteredUnits = this.applyFilters(units);
          const filteredUnitsCollections = this.groupUnits(filteredUnits);
          return {
            units: filteredUnits,
            groupedUnits: filteredUnitsCollections,
          };
        })
      )
      .subscribe({
        next: ({ units, groupedUnits }) => {
          this.units = units;
          if (this.isCachedCollectionActive) {
            this.isCachedCollectionActive = false;
          } else {
            this.updateCollections(groupedUnits);
          }
        },
        error: (error) => {
          this.units = [];
          this.isLoadingOldService = false;
          console.error('Error en la carga de servicios:', error);
          this.cdRef.markForCheck();
        },
      }); */

    this.panelVehicleCommunicationService
      .getEventDataCollectionCreate()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((dataCollectionCreate) => {
        if (dataCollectionCreate.variant !== 'undefined') {
          const cacheCollectionsUnits = this.updateCachedCollectionsToAdd(
            this.unitsCollectionOrigin,
            dataCollectionCreate
          );
          const filteredUnitsCollections = this.applyFiltersToOperationGroups(
            cacheCollectionsUnits
          );
          // this.updateCollections(filteredUnitsCollections);
          this.unitCollectionService.setUnitsCollection =
            filteredUnitsCollections;
          this.isCachedCollectionActive = true;
        }
      });
    this.newVehicleService.reloadUnits();
  }

  private applyFiltersToOperationGroups(
    collections: OperationGroup[]
  ): OperationGroup[] {
    let filtered = [...collections];

    if (this.isActiveButtonToggleContainer) {
      filtered = this.filterOperationsByTransmissionStatus(
        filtered,
        this.transmissionStatusIdButtonToggleContainer
      );
    }

    if (this.valueEventFilter.isActive) {
      filtered = this.applySearchFilterToOperations(
        this.valueEventFilter.value,
        filtered
      );
    }
    return this.removeEmptyCollections(filtered);
  }

  private filterOperationsByTransmissionStatus(
    operations: OperationGroup[],
    transmissionStatusId: number
  ): OperationGroup[] {
    return operations.map((operation) => ({
      ...operation,
      groups: operation.groups.map((group) => ({
        ...group,
        convoys: group.convoys.map((convoy) => ({
          ...convoy,
          units: convoy.units.filter(
            (unit) => unit.transmissionStatusId === transmissionStatusId
          ),
        })),
      })),
    }));
  }

  private applySearchFilterToOperations(
    searchTerm: string,
    operations: OperationGroup[]
  ): OperationGroup[] {
    if (!searchTerm.trim()) return operations;

    const lowerTerm = searchTerm.toLowerCase();

    return operations.map((operation) => ({
      ...operation,
      groups: operation.groups.map((group) => ({
        ...group,
        convoys: group.convoys.map((convoy) => ({
          ...convoy,
          units: convoy.units.filter((unit) => {
            const imei = unit.device?.IMEI?.toString().toLowerCase() || '';
            const licensePlate =
              unit.licensePlate?.toString().toLowerCase() || '';
            const code = unit.internalCode?.toString().toLowerCase() || '';
            const unitName = unit.unitName?.toString().toLowerCase() || '';

            return (
              imei.includes(lowerTerm) ||
              licensePlate.includes(lowerTerm) ||
              code.includes(lowerTerm) ||
              unitName.includes(lowerTerm)
            );
          }),
        })),
      })),
    }));
  }

  private removeEmptyCollections(
    operations: OperationGroup[]
  ): OperationGroup[] {
    return operations
      .map((operation) => ({
        ...operation,
        groups: operation.groups
          .map((group) => ({
            ...group,
            convoys: group.convoys.filter(
              (convoy) => convoy.idConvoy === 0 || convoy.units.length > 0
            ),
          }))
          .filter(
            (group) =>
              group.idGrupo === 0 ||
              group.convoys.some((convoy) => convoy.units.length > 0)
          ),
      }))
      .filter((operation) =>
        operation.groups.some((group) =>
          group.convoys.some((convoy) => convoy.units.length > 0)
        )
      );
  }

  trackByOperation(_index: number, item: OperationGroup): number {
    return item.idOperation;
  }

  trackByGroup(_index: number, item: Group): number {
    return item.idGrupo;
  }

  trackByConvoy(_index: number, item: Convoy): number {
    return item.idConvoy;
  }

  trackByUnit(_index: number, item: UnitWithTransmissionStatus): string {
    return item.device.IMEI;
  }

  onClickGroup() {
    this.eventDisplayGroup.emit(true);
  }

  getValueFromKeyUpEvent(event: { value: string; isEmpty: boolean }): void {
    this.valueEventFilter.isActive = !event.isEmpty;
    this.valueEventFilter.value = event.value;
    this.unitCollectionService.applyFilterForSearchPublic(
      event.value,
      !event.isEmpty
    );
  }

  onClickButtonToggleContainer(event: {
    transmissionStatusId: number;
    isActive: boolean;
  }) {
    this.isActiveButtonToggleContainer = event.isActive;
    this.transmissionStatusIdButtonToggleContainer = event.transmissionStatusId;

    this.unitCollectionService.applyFilterForTransmissionPublic(
      event.transmissionStatusId,
      event.isActive
    );
  }

  convertSecondsToTimeString(seconds: number): string {
    return convertSecondsToTimeString(seconds, {
      shortFormat: true,
      showZeros: false,
    });
  }

  /* IMPLEMENTACION ANTIGUA DE MOSTRAR/OCULTAR UNITS EN EL MAPA */
  changeDisplay(event: DisplayCollectionEvent) {
    const filteredVehicles = this.filterVehiclesByVariantCollection(event);
    const vehiclesOld = this._oldVehicleService.vehicles;
    if (filteredVehicles && filteredVehicles.length > 0) {
      const imeis = filteredVehicles.map((vehicle) => vehicle.IMEI.toString());
      this.vehicleEyeStateService.toggleVehiclesVisibility(imeis, event.isShow);
      this.stateVehicleService.setVisibleGroup(imeis, event.isShow);

      vehiclesOld
        .filter((vehicle) => imeis.includes(vehicle.IMEI?.toString() ?? ''))
        .forEach((vehicle) => {
          vehicle.eye = event.isShow;
        });
      this._oldVehicleService.countOpenEyes = event.isShow
        ? this._oldVehicleService.countOpenEyes + filteredVehicles.length
        : this._oldVehicleService.countOpenEyes - filteredVehicles.length;
      this._oldVehicleService.drawIconMap.emit();
    }
  }

  private filterVehiclesByVariantCollection(
    event: DisplayCollectionEvent
  ): any[] {
    if (!this.oldUnits || this.oldUnits.length === 0) {
      return [];
    }
    switch (event.variant) {
      case 'operacion':
        return this.oldUnits.filter(
          (vehicle: any) => vehicle.idoperation == event.id.idOperation
        );
      case 'grupo':
        return this.oldUnits.filter(
          (vehicle: any) =>
            vehicle.idoperation == event.id.idOperation &&
            vehicle.idgrupo == event.id.idGroup
        );
      case 'convoy':
        return this.oldUnits.filter(
          (vehicle: any) =>
            vehicle.idoperation == event.id.idOperation &&
            vehicle.idgrupo == event.id.idGroup &&
            vehicle.idconvoy == event.id.idConvoy
        );
      default:
        console.log(
          'Dato corrupto en el atributo variante para vehicle-collection'
        );
        return [];
    }
  }

  /* private async emitVehiclesClickEye(vehicles: UserTracker[], show: boolean) {
    vehicles.forEach((vh: UserTracker) => {
      this._oldVehicleService.setGroupingShow.emit({ vh, show });
    });
  } */

  /* IMPLEMENTACION ANTIGUA DE ELIMINAR OPERACION/GRUPO/CONVOY */
  private idDelete?: number;
  private textDelete?: string;
  private typeDelete?: string;
  showDelete(event: CollectionActionEvent) {
    // falta validacion si aun existe el id en la bd
    switch (event.variant) {
      case 'operacion':
        this.idDelete = event.id.idOperation;
        break;
      case 'grupo':
        this.idDelete = event.id.idGroup;
        break;
      case 'convoy':
        this.idDelete = event.id.idConvoy;
        break;
      default:
        Swal.fire({
          title: 'Error',
          text: 'Internal error 500',
          icon: 'error',
        });
        return;
    }
    this.textDelete = event.variant;
    this.typeDelete = event.variant;

    if (this.textDelete == 'grupo') {
      const existsElement = this.units.some((unit) => {
        return unit.idGrupo == this.idDelete && unit.idConvoy != 0;
      });
      if (existsElement) {
        Swal.fire({
          title: 'Error',
          text: 'Primero Debe Eliminar los convoy que tiene el grupo ...',
          icon: 'error',
        });
        return;
      }
    } else if (this.textDelete == 'operacion') {
      const existsElement = this.units.some((unit) => {
        return (
          unit.idOperation == this.idDelete &&
          (unit.idGrupo != 0 || unit.idConvoy != 0)
        );
      });
      if (existsElement) {
        Swal.fire({
          title: 'Error',
          text: 'Primero Debe Eliminar los grupos y/o convoys que tiene la operación ...',
          icon: 'error',
        });
        return;
      }
    }

    Swal.fire({
      title: 'Confirmación',
      text: `¿Está seguro de descomponer, ${this.textDelete}: ${event.nameVariant}?`,
      icon: 'warning',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Descomponer',
      cancelButtonText: 'Cancelar',
      customClass: {
        actions: 'w-100',
        cancelButton: 'col-4',
        confirmButton: 'col-4',
      },
      preConfirm: async () => {
        await this.onDelete();
      },
    }).then((data) => {
      if (data.isConfirmed) {
        this.newVehicleService.reloadUnits();
        const cacheCollectionsUnits = this.updateCachedCollectionsToDelete(
          event,
          this.unitsCollectionOrigin
        );
        const filteredUnitsCollections = this.applyFiltersToOperationGroups(
          cacheCollectionsUnits
        );
        this.unitCollectionService.setUnitsCollection =
          filteredUnitsCollections;
        // SE PODRIA USAR EN EL SERVICIO ESTE BOLEANO
        this.isCachedCollectionActive = true;
        Swal.fire(
          'Descomponer',
          `Descomposición de ${this.typeDelete} exitosa`,
          'success'
        );
      }
    });
  }

  async onDelete() {
    const req = {
      id: this.idDelete,
      type: this.typeDelete,
      vehicles: null,
    };

    await this._vehicleConfigService
      .putGroupDelete(req)
      .toPromise()
      .then((info) => {
        if (info.res) {
          let newVehicles = info.vehicles;
          let oldVehicles = this._oldVehicleService.vehicles;
          for (const key in newVehicles) {
            for (const j in oldVehicles) {
              if (newVehicles[key]['id'] == oldVehicles[j]['id']) {
                if (this.typeDelete == 'operacion') {
                  oldVehicles[j]['idoperation'] = 0;
                  oldVehicles[j]['nameoperation'] = 'Unidades sin operación';
                } else if (this.typeDelete == 'grupo') {
                  oldVehicles[j]['idgrupo'] = 0;
                  oldVehicles[j]['namegrupo'] = 'Unidades sin grupo';
                } else if (this.typeDelete == 'convoy') {
                  oldVehicles[j]['idconvoy'] = 0;
                  oldVehicles[j]['nameconvoy'] = 'Unidades sin convoy';
                }
              }
            }
          }
          this._oldVehicleService.vehicles = oldVehicles;
          this.textDelete = info.message;
          // this.displayDelete = false;
          this.idDelete = -1;
          this.typeDelete = '';
        }
      })
      .catch((errorMsg) => {
        console.log('Error al descomponer grupo/convoy: ', errorMsg);
      });
  }

  // FALTA QUE AL ELIMINAR UNA COLLECION NO NECESARIAMENTE DESAPARENSCAN LAS UNIDADES SINO SE MUEVAN A UNIDADES SIN COLLECION
  private updateCachedCollectionsToDelete(
    event: CollectionActionEvent,
    collectionUnits: OperationGroup[]
  ): OperationGroup[] {
    const { idOperation, idGroup, idConvoy } = event.id;
    let cacheCollectionsUnits = [...collectionUnits];

    if (event.variant === 'convoy') {
      cacheCollectionsUnits.forEach((operation) => {
        if (operation.idOperation === idOperation) {
          operation.groups.forEach((group) => {
            if (group.idGrupo === idGroup) {
              // Obtener las unidades del convoy a eliminar
              const convoyToDelete = group.convoys.find(
                (c) => c.idConvoy === idConvoy
              );
              if (convoyToDelete) {
                // Mover unidades al convoy por defecto (id = 0)
                const defaultConvoy = group.convoys.find(
                  (c) => c.idConvoy === 0
                );
                if (defaultConvoy) {
                  defaultConvoy.units = [
                    ...defaultConvoy.units,
                    ...convoyToDelete.units,
                  ];
                }
                // Eliminar el convoy original
                group.convoys = group.convoys.filter(
                  (convoy) => convoy.idConvoy !== idConvoy
                );
              }
            }
          });
        }
      });
    } else if (event.variant === 'grupo') {
      cacheCollectionsUnits.forEach((operation) => {
        if (operation.idOperation === idOperation) {
          // Obtener todas las unidades del grupo a eliminar (solo del convoy 0)
          const groupToDelete = operation.groups.find(
            (g) => g.idGrupo === idGroup
          );
          if (groupToDelete) {
            const unitsToMove =
              groupToDelete.convoys.find((c) => c.idConvoy === 0)?.units || [];

            // Mover unidades al grupo por defecto (id = 0)
            const defaultGroup = operation.groups.find((g) => g.idGrupo === 0);
            if (defaultGroup) {
              const defaultConvoy = defaultGroup.convoys.find(
                (c) => c.idConvoy === 0
              );
              if (defaultConvoy) {
                defaultConvoy.units = [...defaultConvoy.units, ...unitsToMove];
              }
            }
            // Eliminar el grupo original
            operation.groups = operation.groups.filter(
              (group) => group.idGrupo !== idGroup
            );
          }
        }
      });
    } else if (event.variant === 'operacion') {
      // Obtener todas las unidades de la operación (solo del grupo 0 y convoy 0)
      const operationToDelete = cacheCollectionsUnits.find(
        (op) => op.idOperation === idOperation
      );

      if (operationToDelete) {
        const unitsToMove =
          operationToDelete.groups
            .find((g) => g.idGrupo === 0)
            ?.convoys.find((c) => c.idConvoy === 0)?.units || [];

        // Mover unidades a la operación por defecto (id = 0)
        const defaultOperation = cacheCollectionsUnits.find(
          (op) => op.idOperation === 0
        );
        if (defaultOperation) {
          const defaultGroup = defaultOperation.groups.find(
            (g) => g.idGrupo === 0
          );
          if (defaultGroup) {
            const defaultConvoy = defaultGroup.convoys.find(
              (c) => c.idConvoy === 0
            );
            if (defaultConvoy) {
              defaultConvoy.units = [...defaultConvoy.units, ...unitsToMove];
            }
          }
        }
        // Eliminar la operación original
        cacheCollectionsUnits = cacheCollectionsUnits.filter(
          (operation) => operation.idOperation !== idOperation
        );
      }
    }

    // console.log('cacheCollectionsUnits', cacheCollectionsUnits);
    return cacheCollectionsUnits;
  }

  private updateCachedCollectionsToAdd(
    collectionUnits: OperationGroup[],
    dataCollectionCreate: DataCollectionCreate
  ): OperationGroup[] {
    let cacheCollectionsUnits = collectionUnits;
    const idVariant = -9999999;
    let filteredUnits: UnitWithTransmissionStatus[] = [];

    // se puede mejorar el codigo para realizar todo en un solo bucle
    // accion de agregar unidades movidas al nuevo convoy/grupo/operacion
    switch (dataCollectionCreate.variant) {
      case 'operation':
        let newUnits: UnitWithTransmissionStatus[] = [];
        cacheCollectionsUnits.forEach((operation) => {
          operation.groups.forEach((group) => {
            group.convoys.forEach((convoy) => {
              filteredUnits = convoy.units.filter((unit) =>
                dataCollectionCreate.data.includes(unit.device.IMEI.toString())
              );
              newUnits.push(...filteredUnits);
            });
          });
        });

        const newOperation: OperationGroup = {
          idOperation: idVariant,
          nameOperation: dataCollectionCreate.nameVariant,
          groups: [
            {
              idGrupo: 0,
              nameGroup: 'Sin grupo',
              convoys: [
                {
                  idConvoy: 0,
                  nameConvoy: 'Sin convoy',
                  units: newUnits,
                },
              ],
            },
          ],
        };
        cacheCollectionsUnits.push(newOperation);
        break;

      case 'group':
        const operationIndex = cacheCollectionsUnits.findIndex(
          (op) => op.idOperation === dataCollectionCreate.id.idOperation
        );

        if (operationIndex !== -1) {
          let newUnits: UnitWithTransmissionStatus[] = [];
          collectionUnits[operationIndex].groups.forEach((group) => {
            group.convoys.forEach((convoy) => {
              filteredUnits = convoy.units.filter((unit) =>
                dataCollectionCreate.data.includes(unit.device.IMEI.toString())
              );
              newUnits.push(...filteredUnits);
            });
          });
          const newGroup = {
            idGrupo: idVariant,
            nameGroup: dataCollectionCreate.nameVariant,
            convoys: [
              {
                idConvoy: 0,
                nameConvoy: 'Sin convoy',
                units: newUnits,
              },
            ],
          };
          cacheCollectionsUnits[operationIndex].groups.push(newGroup);
        }
        break;

      case 'convoy':
        const operation = cacheCollectionsUnits.find(
          (op) => op.idOperation === dataCollectionCreate.id.idOperation
        );
        if (operation) {
          const group = operation.groups.find(
            (g) => g.idGrupo === dataCollectionCreate.id.idGroup
          );
          if (group) {
            let newUnits: UnitWithTransmissionStatus[] = [];
            group.convoys.forEach((convoy) => {
              filteredUnits = convoy.units.filter((unit) =>
                dataCollectionCreate.data.includes(unit.device.IMEI.toString())
              );
              newUnits.push(...filteredUnits);
            });

            const newConvoy = {
              idConvoy: idVariant,
              nameConvoy: dataCollectionCreate.nameVariant,
              units: newUnits,
            };
            group.convoys.push(newConvoy);
          }
        }
        break;
    }
    // accion de eliminar unidades movidas
    cacheCollectionsUnits = cacheCollectionsUnits
      .map((operation) => {
        if (operation.idOperation === idVariant) {
          return operation;
        }
        return {
          ...operation,
          groups: operation.groups.map((group) => ({
            ...group,
            convoys: group.convoys.map((convoy) => ({
              ...convoy,
              units: convoy.units.filter((unit) => {
                const shouldRemove = filteredUnits.some(
                  (filteredUnit) =>
                    filteredUnit.device.IMEI === unit.device.IMEI &&
                    filteredUnit.idOperation === operation.idOperation &&
                    filteredUnit.idGrupo === group.idGrupo &&
                    filteredUnit.idConvoy === convoy.idConvoy
                );
                return !shouldRemove;
              }),
            })),
          })),
        };
      })
      .filter(
        (operation) =>
          operation.idOperation === idVariant ||
          operation.groups.some((group) =>
            group.convoys.some((convoy) => convoy.units.length > 0)
          )
      );

    const sortedOperations = Array.from(cacheCollectionsUnits.values()).sort(
      (a, b) => (a.idOperation === 0 ? 1 : b.idOperation === 0 ? -1 : 0)
    );

    sortedOperations.forEach((operation) => {
      operation.groups.sort((a, b) =>
        a.idGrupo === 0 ? 1 : b.idGrupo === 0 ? -1 : 0
      );
      operation.groups.forEach((group) => {
        group.convoys.sort((a, b) =>
          a.idConvoy === 0 ? 1 : b.idConvoy === 0 ? -1 : 0
        );
      });
    });

    return sortedOperations;
  }

  /* IMPLEMENTACION ANTIGUA DE EDITAR OPERACION/GRUPO/CONVOY */
  public displayEditGroup: boolean = false;
  public textHeaderEdit: string = '';
  public loading: boolean = false;
  public readonlyNameGroup: boolean = false;
  public list1: any = [];
  public list2: any = [];
  public selectedList1: any = [];
  public selectedList2: any = [];

  private dataEdit: any = {
    id: -1,
    name: '',
    type: '',
  };
  @ViewChild('nameEdit', { static: true }) nameEdit!: ElementRef;

  showEditGroup(event: CollectionActionEvent) {
    this.displayEditGroup = true;
    this.textHeaderEdit =
      (event.variant === 'operacion' ? 'operación' : event.variant) +
      ' ' +
      event.nameVariant;
    this.nameEdit.nativeElement.value = event.nameVariant;
    this.readonlyNameGroup = false;

    this.dataEdit.type = event.variant;
    this.dataEdit.name = event.nameVariant;

    const vehicles = this.oldUnits;
    let aux1: any = [];
    let aux2 = [];
    let aux_idgrupo = -1;

    const isFree = (v: any) =>
      v.idoperation === 0 &&
      v.idgrupo === 0 &&
      v.idconvoy === 0;

    const isWithoutConvoy = (v: any) => v.idconvoy === 0;

    switch (event.variant) {
      case 'operacion':
        this.dataEdit.id = event.id.idOperation;

        aux2 = vehicles.filter(
          (v: any) =>
            v.idoperation === event.id.idOperation &&
            v.idgrupo === 0 &&
            v.idconvoy === 0
        );

        aux1 = this.oldUnits.filter(isFree);
        break;

      case 'grupo':
        this.dataEdit.id = event.id.idGroup;

        aux2 = vehicles.filter(
          (v: any) =>
            v.idgrupo === event.id.idGroup &&
            isWithoutConvoy(v)
        );

        aux1 = this.oldUnits.filter(
          (v: any) =>
            v.idoperation === event.id.idOperation &&
            v.idgrupo === 0 &&
            v.idconvoy === 0
        );
        break;

      case 'convoy':
        this.dataEdit.id = event.id.idConvoy;

        aux2 = vehicles.filter(
          (v: any) =>
            v.idconvoy === event.id.idConvoy
        );

        aux1 = this.oldUnits.filter(
          (v: any) =>
            v.idoperation === event.id.idOperation &&
            v.idgrupo === event.id.idGroup &&
            v.idconvoy === 0
        );
        break;
    }

    this.list2 = aux2;
    this.list1 = aux1;
  }

  upList1() {
    // this.list1=this.selectedList2;
    // this.selectedList2=[];
    let aux: any = [];

    //recupero valores upList2
    for (const key in this.list1) {
      aux.push(this.list1[key]);
    }
    // inserto valores nuevos
    // //console.log('subir a lista 2');
    for (const key in this.selectedList2) {
      // let index = aux.indexOf(this.selectedList2[key]);
      // //console.log("index====",index);
      aux.push(this.selectedList2[key]);
      //console.log(this.selectedList2[key]);
    }
    //inserto valores en list1
    this.list1 = aux;
    //vacio valores de list 2
    let aux2: any = [];
    let aux_status = false;
    for (const key in this.list2) {
      let aux_status = false;
      for (const key2 in this.selectedList2) {
        if (this.list2[key] == this.selectedList2[key2]) {
          aux_status = true;
        }
      }
      if (!aux_status) {
        aux2.push(this.list2[key]);
      }
    }
    this.list2 = aux2;
    this.selectedList2 = [];
  }
  upList2() {
    // this.list2=this.selectedList1;
    // this.selectedList1=[];
    let aux: any = [];

    //recupero valores upList2
    for (const key in this.list2) {
      aux.push(this.list2[key]);
    }
    // inserto valores nuevos
    // //console.log('subir a lista 2');
    for (const key in this.selectedList1) {
      // let index = aux.indexOf(this.selectedList1[key]);
      // //console.log("index====",index);
      aux.push(this.selectedList1[key]);
      // //console.log(this.selectedList1[key]);
    }
    //inserto valores en list2
    this.list2 = aux;
    //vacio valores de list 1
    let aux2: any = [];
    let aux_status = false;
    for (const key in this.list1) {
      let aux_status = false;
      for (const key2 in this.selectedList1) {
        if (this.list1[key] == this.selectedList1[key2]) {
          aux_status = true;
        }
      }
      if (!aux_status) {
        aux2.push(this.list1[key]);
      }
    }
    this.list1 = aux2;
    this.selectedList1 = [];
  }

  onConfirmationEdit() {
    this.loading = true;
    //let currName = this.nameEdit.nativeElement.value;
    let currType = this.dataEdit.type;
    // console.log('currType: ', currType);
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Se aplicarán los cambios',
      //icon: 'warning',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        actions: 'w-100',
        cancelButton: 'col-4',
        confirmButton: 'col-4',
      },
      preConfirm: async () => {
        if (currType == 'pinUp') {
          // await this.onSubmitEditFixes();
        } else {
          await this.onSubmitEdit();
        }
      },
    }).then((data) => {
      if (currType == 'pinUp') {
        if (data.isConfirmed) {
          this.newVehicleService.reloadUnits();
          Swal.fire(
            'Éxito',
            `Las unidades Fijadas se editaron exitosamente`,
            'success'
          );
        } else {
          console.log(
            `(Vehicle fixes) Hubo un error al editar las unidades Fijadas`
          );
        }
      } else {
        if (data.isConfirmed) {
          this.newVehicleService.reloadUnits();
          Swal.fire(
            'Éxito',
            `${
              currType == 'operacion' ? 'La' : 'El'
            } ${currType} se editó exitosamente`,
            'success'
          );
        } else {
          console.log(`(Vehicle Group) Hubo un error al editar el ${currType}`);
        }
      }

      this.loading = false;
    });
  }

  async onSubmitEdit() {
    // //console.log('eviando data para edicion');
    if (this._oldVehicleService.demo) {
      //console.log('modo demo, no se enviara info a la DB');
      this.updateGroup();

      this._oldVehicleService.reloadTableTree.emit();
      // emitir evento para actualizar panel vehiculos
      this.displayEditGroup = false;
    } else {
      const list1Filtered = this.list1.map((item: UserTracker) => ({
        id: item.id,
        IMEI: item.IMEI,
        idoperation: item.idoperation,
        idgrupo: item.idgrupo,
        idconvoy: item.idconvoy,
        nameoperation: item.nameoperation,
        namegrupo: item.namegrupo,
        nameconvoy: item.nameconvoy,
      }));
      const list2Filtered = this.list2.map((item: UserTracker) => ({
        id: item.id,
        IMEI: item.IMEI,
        idoperation: item.idoperation,
        idgrupo: item.idgrupo,
        idconvoy: item.idconvoy,
        nameoperation: item.nameoperation,
        namegrupo: item.namegrupo,
        nameconvoy: item.nameconvoy,
      }));
      const req = {
        type: this.dataEdit.type,
        id: this.dataEdit.id,
        // list1: this.list1,
        list1: list1Filtered,
        // list2: this.list2,
        list2: list2Filtered,
        name: this.nameEdit.nativeElement.value,
      };
      await this._vehicleConfigService
        .putGroupUpdate(req)
        .toPromise()
        .then((info) => {
          if (info.res) {
            this.updateGroup();
            this._oldVehicleService.reloadTableTree.emit();
            this.displayEditGroup = false;
          } else {
          }
        })
        .catch((errorMsg) => {
          console.log(errorMsg);
        });
    }
  }

  updateGroup() {
    const vehicles = this._oldVehicleService.vehicles;
    if (this.dataEdit.type == 'operacion') {
      this.list1.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idoperation = 0;
          vehicles[index].nameoperation = 'Unidades sin operación';
        } else {
          console.warn('Vehículo no encontrado para IMEI:', item.IMEI);
        }
      });
      this.list2.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idoperation = this.dataEdit.id;
          vehicles[index].nameoperation = this.nameEdit.nativeElement.value;
        }
      });
      vehicles
        .filter((v) => v.idoperation == this.dataEdit.id)
        .forEach((v) => {
          v.nameoperation = this.nameEdit.nativeElement.value;
        });
    } else if (this.dataEdit.type == 'grupo') {
      this.list1.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idgrupo = 0;
          vehicles[index].namegrupo = 'Unidades sin grupo';
        }
      });
      this.list2.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idgrupo = this.dataEdit.id;
          vehicles[index].namegrupo = this.nameEdit.nativeElement.value;
        }
      });
      vehicles
        .filter((v) => v.idgrupo == this.dataEdit.id)
        .forEach((v) => {
          v.namegrupo = this.nameEdit.nativeElement.value;
        });
    } else if (this.dataEdit.type == 'convoy') {
      this.list1.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idconvoy = 0;
          vehicles[index].nameconvoy = 'Unidades sin convoy';
        }
      });
      this.list2.forEach((item: UserTracker) => {
        let index = vehicles.findIndex((v) => v.IMEI == item.IMEI);
        if (index !== -1) {
          vehicles[index].idconvoy = this.dataEdit.id;
          vehicles[index].nameconvoy = this.nameEdit.nativeElement.value;
        }
      });
      vehicles
        .filter((v) => v.idconvoy == this.dataEdit.id)
        .forEach((v) => {
          v.nameconvoy = this.nameEdit.nativeElement.value;
        });
    } else {
      console.log('Update Units Fixes...');
    }

    this._oldVehicleService.vehicles = vehicles;
    this.oldUnits = vehicles;
    this._oldVehicleService.vehiclesTree =
      this._oldVehicleService.createNode(vehicles);
  }

  private resetFollowVehicles(): void {
    if (this.oldUnits.length > 0) {
      this.oldUnits.forEach((vehicle) => {
        if (vehicle.follow) {
          vehicle.follow = false;
          this.mapService.setFollowVehicle(vehicle);
        }
      });
      this.followService.emitResetFollow();
    }
  }

  /* Se podria considerar que se desactive incluso en todas las cards */
  onDisabledFollow(): void {
    this.resetFollowVehicles();
  }

  onDisabledFormatedOperation(isDisabled: boolean): void {
    this.isFormatedOperation = isDisabled;
  }

  onDisabledFilterEye(isActive: boolean): void {
    this.isActiveFilterEyer = isActive;
    this.unitCollectionService.applyFilterForEyePublic(isActive);
  }

  toggleCard(imei: string): void {
    this.stateVehicleService.toggleExpanded(imei);
  }

  isCardExpanded(imei: string): boolean {
    return this.vehicleStateLocal.get(imei)?.isExpanded ?? false;
  }

  isViewOptionVisible(imei: string): boolean {
    return this.vehicleStateLocal.get(imei)?.viewOptions.visible ?? true;
  }

  toggleVisible(imei: string): void {
    this.stateVehicleService.toggleVisible(imei);
    if (this.isActiveFilterEyer)
      this.unitCollectionService.applyFilterForEyePublic(true);
  }

  setTrueVisible(imei: string): void {
    this.stateVehicleService.setTrueVisible(imei);
    if (this.isActiveFilterEyer)
      this.unitCollectionService.applyFilterForEyePublic(true);
  }

  isViewOptionFollow(imei: string): boolean {
    return this.vehicleStateLocal.get(imei)?.viewOptions.follow ?? false;
  }

  toggleFollow(imei: string): void {
    this.stateVehicleService.toggleFollow(imei);
  }

  isViewOptionShowDriver(imei: string): boolean {
    return this.vehicleStateLocal.get(imei)?.viewOptions.showDriver ?? false;
  }

  toggleShowDriver(imei: string): void {
    this.stateVehicleService.toggleShowDriver(imei);
  }

  isViewOptionShowName(imei: string): boolean {
    return this.vehicleStateLocal.get(imei)?.viewOptions.showName ?? true;
  }

  toggleShowName(imei: string): void {
    this.stateVehicleService.toggleShowName(imei);
  }

  getViewOptionState(imei: string): ViewOptionState {
    return (
      this.vehicleStateLocal.get(imei)?.viewOptions ?? {
        showDriver: false,
        showName: true,
        follow: false,
        visible: true,
      }
    );
  }

  getNameDriverByImei(imei: string): string {
    const descriptionDriver =
      this.managerDriversServices.getDescriptionDriverByImei(imei);
    if (!descriptionDriver) return '';
    const nameDriver = descriptionDriver.long_name;
    return nameDriver ? nameDriver : 'Conductor desconocido';
  }

  getTemperatureBleTemperature(unit: UnitWithTransmissionStatus): {
    value: number;
    variant: 'disabled' | 'hot' | 'cold' | 'medium';
    typeGps: string;
  } {
    const typeGps = unit.device.IOs.type?.toString() || '';

    const temps: number[] = [];

    for (let i = 1; i <= 4; i++) {
      const key = `BLE Temperature #${i}`;
      const value = unit.device.IOs?.[key];

      if (typeof value === 'number' && value >= -40 && value <= 125) {
        temps.push(value);
      }
    }

    if (temps.length === 0) return { value: 0, variant: 'disabled', typeGps };

    // promediamos la temperatura de los 4 parametros
    const avgRaw = temps.reduce((a, b) => a + b, 0) / temps.length;
    const avg = parseFloat(avgRaw.toFixed(2));

    // condiciones de temperatura MOMENTANEO RAFA
    if (avg < 10) return { value: avg, variant: 'cold', typeGps };
    if (avg > 30) return { value: avg, variant: 'hot', typeGps };
    return { value: avg, variant: 'medium', typeGps };
  }

  getTemperatureEyeTemperature(unit: UnitWithTransmissionStatus): {
    value: number;
    variant: 'disabled' | 'hot' | 'cold' | 'medium';
    typeGps: string;
  } {
    // mientras unit no transmita tipoGps
    const typeGps = unit.device.IOs.type?.toString() || '';

    const temps: number[] = [];

    for (let i = 1; i <= 4; i++) {
      const key = `EYE Temperature ${i}`;
      const value = unit.device.IOs?.[key];

      if (typeof value === 'number' && value >= -40 && value <= 125) {
        temps.push(value);
      }
    }

    if (temps.length === 0)
      return { value: 0, variant: 'disabled', typeGps: typeGps };

    // promediamos la temperatura de los 4 parametros
    const avgRaw = temps.reduce((a, b) => a + b, 0) / temps.length;
    const avg = parseFloat(avgRaw.toFixed(2));

    // condiciones de temperatura MOMENTANEO RAFA
    if (avg < 10) return { value: avg, variant: 'cold', typeGps };
    if (avg > 30) return { value: avg, variant: 'hot', typeGps };
    return { value: avg, variant: 'medium', typeGps };
  }

  getHumidityBle(unit: UnitWithTransmissionStatus): {
    value: number;
    variant: 'disabled' | 'dry' | 'normal' | 'humid';
    typeGps: string;
  } {
    const typeGps = unit.device.IOs.type?.toString() || '';

    const values: number[] = [];

    for (let i = 1; i <= 4; i++) {
      const key = `BLE Humidity #${i}`;
      const raw = unit.device.IOs?.[key];

      // valor válido: entre 0 y 1000 directamente
      if (typeof raw === 'number' && raw >= 0 && raw <= 1000) {
        values.push(raw / 10); // convertimos a %RH real
      }
    }

    if (values.length === 0) return { value: 0, variant: 'disabled', typeGps };

    const avgRaw = values.reduce((a, b) => a + b, 0) / values.length;
    const avg = parseFloat(avgRaw.toFixed(2));

    if (avg < 30) return { value: avg, variant: 'dry', typeGps };
    if (avg > 60) return { value: avg, variant: 'humid', typeGps };
    return { value: avg, variant: 'normal', typeGps };
  }

  getHumidityEye(unit: UnitWithTransmissionStatus): {
    value: number;
    variant: 'disabled' | 'dry' | 'normal' | 'humid';
    typeGps: string;
  } {
    const typeGps = unit.device.IOs.type?.toString() || '';

    const values: number[] = [];

    for (let i = 1; i <= 4; i++) {
      const key = `EYE Humidity ${i}`;
      const raw = unit.device.IOs?.[key];

      // valor válido: entre 0 y 100 directamente
      if (typeof raw === 'number' && raw >= 0 && raw <= 100) {
        values.push(raw);
      }
    }

    if (values.length === 0) {
      return { value: 0, variant: 'disabled', typeGps };
    }

    const avgRaw = values.reduce((a, b) => a + b, 0) / values.length;
    const avg = parseFloat(avgRaw.toFixed(2));

    if (avg < 30) return { value: avg, variant: 'dry', typeGps };
    if (avg > 60) return { value: avg, variant: 'humid', typeGps };
    return { value: avg, variant: 'normal', typeGps };
  }

  adaptDetailIos(
    IOs: any,
    unit?: UnitWithTransmissionStatus
  ): { label: string; value: string; variant: 'default' | 'edit' }[] {
    if (!IOs || typeof IOs !== 'object') return [];

    return Object.entries(IOs)
      .filter(([_, value]) => value !== null && value !== undefined)
      .map(
        ([key, value]) =>
          ({
            label: key.toUpperCase(),
            value: String(value),
            variant: 'default',
          } as const)
      )
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  ngOnDestroy(): void {
    // this.resetFollowVehicles();
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
    this.unitCollectionService.clearFilters();
    this.units = [];
    this.unitsCollectionOrigin = [];
    this.oldUnits = [];
  }

  followVehicles(event: CollectionActionEvent) {
    console.log('followVehicles: ', event);
    let type: string = 'none';
    let trackerImeis: UnitItem[] = [];
    let eventID: number = 0;
    const vehicles = this.oldUnits;
    console.log('Event :', event.id);
    console.log('vehicles: ', vehicles[0]);
    if (event.variant === 'operacion') {
      trackerImeis = vehicles
        .filter((vehicle) => vehicle.idoperation === event.id.idOperation)
        .map((tracker_unit) => {
          return {
            id: tracker_unit.id,
            nombre: tracker_unit.name!,
            operation: tracker_unit.nameoperation,
            selected: false,
            type: 'tracker',
            imeis: [tracker_unit.IMEI!.toString()],
          };
        });
      type = 'Operación: ';
      eventID = event.id.idOperation;
    } else if (event.variant === 'grupo') {
      trackerImeis = vehicles
        .filter((vehicle) => vehicle.idgrupo === event.id.idGroup)
        .map((tracker_unit) => {
          return {
            id: tracker_unit.id,
            nombre: tracker_unit.name!,
            operation: tracker_unit.nameoperation,
            selected: false,
            type: 'tracker',
            imeis: [tracker_unit.IMEI!.toString()],
          };
        });
      type = 'Grupo: ';
      eventID = event.id.idGroup ?? 0;
    } else if (event.variant === 'convoy') {
      trackerImeis = vehicles
        .filter((vehicle) => vehicle.idconvoy === event.id.idConvoy)
        .map((tracker_unit) => {
          return {
            id: tracker_unit.id,
            nombre: tracker_unit.name!,
            operation: tracker_unit.nameoperation,
            selected: false,
            type: 'tracker',
            imeis: [tracker_unit.IMEI!.toString()],
          };
        });
      type = 'Convoy: ';
      eventID = event.id.idConvoy ?? 0;
    }

    const defaultStructureGrid: StructureGrid = {
      row: 1,
      col: 1,
      span: 1,
      gridItem_id: eventID.toString(),
    };

    let structures =
      this.multiviewService.calculateStructureFromUnitItems(trackerImeis);
    let gridItems = []; // por cada vehiculo es crear un grid ( tampoco lo entiendo :( )
    for (let item of trackerImeis) {
      gridItems.push({
        structure: structures.find((st) => st.gridItem_id == item.nombre)!,
        content_type: 'minimap',
        show_only_label: true,
        content: item,
        label: item.nombre,
        title:
          item.nombre + (item.operation ? ' (' + item.operation + ')' : ''),
      });
    }

    const newMultiview: ScreenView = {
      name: event.nameVariant ?? 'default',
      grids: gridItems,
      is_group: true,
      title_group:
        type != 'none' ? type + event.nameVariant : event.nameVariant,
    };

    console.log('newMultiview: ', newMultiview);
    console.log('EstructureGrid: ', defaultStructureGrid);

    this.multiviewService.userMultiview =
      this.multiviewService.userMultiview.filter(
        (item) => item.name !== newMultiview.name
      );
    this.multiviewService.userMultiview.push(newMultiview);
    this.multiviewService.openScreenView(newMultiview.name);
  }
}
